/** InsCoder WANG.J 2026-02-02 B + M2 Benefits Section JavaScript for Terms & Conditions popup **/

(function() {
  'use strict';

  /**
   * M2 Benefits Section - Terms & Conditions Popup Controller
   */
  class M2BenefitsPopup {
    constructor(section) {
      this.section = section;
      this.trigger = section.querySelector('[data-terms-trigger]');
      this.popup = section.querySelector('[data-terms-popup]');
      this.closeButtons = section.querySelectorAll('[data-popup-close]');
      
      if (!this.trigger || !this.popup) {
        return;
      }

      this.init();
    }

    init() {
      // Bind events
      this.trigger.addEventListener('click', this.openPopup.bind(this));
      
      this.closeButtons.forEach(button => {
        button.addEventListener('click', this.closePopup.bind(this));
      });

      // Close on Escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.closePopup();
        }
      });
    }

    isOpen() {
      return this.popup.getAttribute('aria-hidden') === 'false';
    }

    openPopup() {
      this.popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      
      // Focus trap - focus on close button
      const closeButton = this.popup.querySelector('.cust-m2-benefits__popup-close');
      if (closeButton) {
        setTimeout(() => closeButton.focus(), 100);
      }
    }

    closePopup() {
      this.popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      
      // Return focus to trigger
      if (this.trigger) {
        this.trigger.focus();
      }
    }
  }

  /**
   * Initialize all M2 Benefits sections on the page
   */
  function initM2BenefitsSections() {
    const sections = document.querySelectorAll('.cust-m2-benefits');
    sections.forEach(section => {
      new M2BenefitsPopup(section);
    });
  }

  // Initialize on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initM2BenefitsSections);
  } else {
    initM2BenefitsSections();
  }

  // Re-initialize on Shopify section load/unload (for theme editor)
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.cust-m2-benefits')) {
      new M2BenefitsPopup(event.target.querySelector('.cust-m2-benefits'));
    }
  });

})();

/** InsCoder WANG.J 2026-02-02 E + M2 Benefits Section JavaScript for Terms & Conditions popup **/
